export const SupplierTypeInput = [
    {key:'Agent', value:'Agent'},
    {key:'Farmer', value:'Farmer'},
    {key:'Broker', value:'Broker'},
]